var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('newsletter'),_c('cart'),_c('router-view',{key:_vm.$route.fullPath}),_c('lp-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }